export default __webpack_public_path__ + "static/media/idea_to_life.4e7fba99.svg";